// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import vuex from 'vuex'
import router from './router'
import axios from 'axios'
import elementUI from 'element-ui';
import $ from 'jquery'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/setScreen.js' // import 'lib-flexible' //禁止删除
// 在main.js（入口）中引入js文件 ---  

// import 'lib-flexible/flexible.js'

import store from './store'
import qs from 'qs'
import "babel-polyfill"
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill() // 在node或浏览器中支持ES6 与CommonJS
Es6Promise.polyfill()

// import alert from './views/alert'

import { Base64 } from 'js-base64'
import JsEncrypt from 'jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt





window.onresize = function () { // 定义窗口大小变更通知事件
  store.state.screenHeight = document.documentElement.clientHeight; //窗口高度
};

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})

history.pushState(null, null, document.URL);
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL)
})

// window.addEventListener('popstate', function() {
//   history.pushState(null, null, document.URL)
// })



Vue.config.productionTip = false
Vue.prototype.$Base64 = Base64;
Vue.prototype.$http = axios;
Vue.prototype.$qs = qs
// Vue 定义自定义指令:防止按钮重复提交
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 1000)
      }
    })
  }
})



Vue.use(elementUI,);

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   vuex,
//   store,
//   router,
//   elementUI,
//   components: { App },
//   template: '<App/>'
// })

new Vue({
  vuex,
  axios,
  elementUI,
  store,
  router,
  $,
  render: h => h(App),
}).$mount('#app')



